import * as Yup from 'yup';

export function validationSchema() {
  return Yup.object({
    email: Yup
      .string()
      .email('Please enter a vaild email address')
      .required('Required'),
    password: Yup
      .string()
      .required('No password provided.')
      .min(6, 'Must contain at least 6 characters'),
    confirmPassword: Yup
      .string()
      .oneOf([Yup.ref('password')], 'Passwords must match'),
    occupation: Yup
      .string()
      .required('No occupation provided.'),
  });
}
